import { LdSelect } from "@liquid/react";
import styled from "@emotion/styled";

const StyledDropdown = styled(LdSelect)<{ width?: number | string }>`
  overflow: hidden;
  width: ${({ width }) => width};
  padding-top: 1rem;
  padding-bottom: 1rem;

  &[role="button"] {
    ::part(div) {
     border: 1px solid #503291;
    background: #8255e4;
    }
  
`;

const StyledDropdownWrapper = styled.div<{
  width?: number | string;
}>`
  overflow: hidden;
  width: ${({ width }) => width};
  position: relative;
`;

export { StyledDropdown, StyledDropdownWrapper };
